import { createApp } from 'vue';
import App from "./App.vue";
import router from "@/routers";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/vue-i18n";
import VueGtag from "vue-gtag";
import settings from "@/settings";
import VueQRCodeComponent from "./components/VueQRCodeComponent.vue";
import {createHead} from "@vueuse/head"




const app = createApp(App);

app.use(createHead())


var gaConnectedSiteTags = settings.gaConnectedSiteTags.split(",");
var vueGtagConnectedSiteTags = [];
for (var i = 0; i < gaConnectedSiteTags.length; i++) {
  vueGtagConnectedSiteTags.push({ id: gaConnectedSiteTags[i] });
}

app.use(
  VueGtag,
  {
    includes: vueGtagConnectedSiteTags,
    config: {
      id: settings.gaMeasurementId,
      params: {
        send_page_view: false,
      },
    },
  },
  router
);

// Register the Vue component
app.component("qr-code", VueQRCodeComponent);
app.use(router);
app.use(store);
app.use(vuetify);
app.use(i18n);
app.mount("#app");
